import {
  ButtonHTMLAttributes,
  ComponentPropsWithRef,
  ComponentType,
  FunctionComponent,
} from "react";
import clsx from "clsx";

interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> {
  icon: ComponentType<ComponentPropsWithRef<"svg">>;
  accent?: "neutral" | "primary" | "destructive";
  circle?: boolean;
}
const Button: FunctionComponent<ButtonProps> = ({
  className,
  icon: Icon,
  circle,
  accent,
  ...htmlButtonAttributes
}) => {
  return (
    <button
      {...htmlButtonAttributes}
      className={clsx(
        className,
        "tw-inline-flex tw-items-center tw-shrink-0 tw-p-2 tw-border-solid tw-border tw-text-base md:tw-text-sm tw-font-medium focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-offset-1",
        accent === "neutral" &&
          "tw-border-gray-300 tw-text-gray-700 tw-bg-white hover:tw-bg-gray-50 focus-visible:tw-ring-indigo-500",
        accent === "primary" &&
          "tw-border-transparent tw-text-white tw-bg-indigo-800 hover:tw-bg-indigo-900 focus-visible:tw-ring-indigo-500",
        accent === "destructive" &&
          "tw-border-transparent tw-text-white tw-bg-red-600 hover:tw-bg-red-700 focus-visible:tw-ring-red-500",
        circle ? "tw-rounded-full" : "tw-rounded",
      )}
    >
      <Icon className="tw-h-5 tw-w-5" aria-hidden="true" />
    </button>
  );
};

Button.defaultProps = {
  accent: "neutral",
};

export default Button;
